import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Button, { ButtonToneProps } from 'src/components/ui/Button/Button';
import { FactsTable } from 'src/components/layouts/FactsTable/FactsTable';
import { OverlaySectionHeadline } from 'src/components/layouts/OverlaySectionHeadline/OverlaySectionHeadline';
import { downloadReturnLabel, ReturnLabelInfo, saveBase64File } from 'src/services/returns';
import logger from 'src/utils/logger';

export function ReturnLabelDownload({ returnPickingId, label }: { returnPickingId: number; label: ReturnLabelInfo }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      saveBase64File(await downloadReturnLabel(returnPickingId));
    } catch (error) {
      logger.error('Failed to download return label', error);
      toast.error(t('errors.fetch_label_failed'), { autoClose: 10000 });
    } finally {
      setIsLoading(false);
    }
  };

  const trackingValue =
    label.tracking_number &&
    (label.tracking_url ? (
      <a className="typo-text-14 text-full underline" href={label.tracking_url} target="_blank" rel="noreferrer">
        {label.tracking_number}
      </a>
    ) : (
      <span className="typo-text-14 text-faded">{label.tracking_number}</span>
    ));

  return (
    <div>
      <div className="flex justify-between items-center">
        <OverlaySectionHeadline>{t('returns.label')}</OverlaySectionHeadline>
        <Button
          title={t('returns.download_label')}
          tone={ButtonToneProps.PRIMARY_BLUE}
          icon="download"
          disabled={isLoading}
          onClick={handleDownload}
        />
      </div>
      <p className="typo-text-14 text-faded mb-16">{t('returns.label_hint')}</p>
      {trackingValue && <FactsTable entries={[[t('returns.tracking_number'), trackingValue]]} />}
    </div>
  );
}
